import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Smartphone, Laptop, GraduationCap, Zap, CheckCircle } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  Smartphone: Smartphone,
  Laptop: Laptop,
  GraduationCap: GraduationCap,
  Zap: Zap
};

const Home = () => {
  const [animateIn, setAnimateIn] = useState(false);

  useEffect(() => {
    setAnimateIn(true);
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative pt-32 md:pt-36 pb-16 md:pb-24 overflow-hidden">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

            {/* Hero Text */}
            <div className={`${animateIn ? 'animate-fade-in' : 'opacity-0'}`}>
              <h1 className="display-large mb-6">
                <span className="inline-block animate-fade-in-up">
                  Welcome to FITNOVEXA
                </span>
              </h1>
              <p className="display-small mb-4 text-[#2D6A4F]">
                {mockData.hero.subtitle}
              </p>
              <p className="body-large mb-8 text-[#2D6A4F]">
                {mockData.hero.description}
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/contact" className="btn-primary text-center">
                  Schedule Consultation
                </Link>
              </div>
            </div>

            {/* Hero Visual */}
            <div className={`${animateIn ? 'animate-fade-in' : 'opacity-0'} transition-opacity delay-200`}>
              <div className="relative rounded-[32px] overflow-hidden shadow-2xl flex justify-center">
                <img
                  src="https://customer-assets.emergentagent.com/job_active-tech-hub/artifacts/za0gl5kz_ChatGPT%20Image%20Oct%2022%2C%202025%2C%2011_49_53%20AM.png"
                  alt="Fitness and Technology Innovation"
                  className="max-w-[180px] sm:max-w-[220px] md:max-w-[300px] lg:max-w-[360px] xl:max-w-[400px] h-auto object-contain rounded-[20px] shadow-[0_0_30px_rgba(184,255,59,0.25)]"
                />
                <div className="absolute bottom-3 left-3 right-3 sm:bottom-4 sm:left-4 sm:right-4">
                  <div className="bg-white/95 backdrop-blur-sm rounded-xl p-2 sm:p-3 md:p-4 text-center shadow-md">
                    <p className="text-base sm:text-lg md:text-xl font-bold text-[#1B4332] mb-1 leading-tight">
                      Transform Through Technology
                    </p>
                    <p className="text-xs sm:text-sm md:text-base text-[#2D6A4F]">
                      Innovation • Excellence
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="heading-1 mb-4">Our Core Services</h2>
            <p className="body-large max-w-2xl mx-auto">
              Four pillars of innovation transforming fitness, wellness and recreation
            </p>
          </div>

          <div className="network-grid">
            {mockData.services.map((service, index) => {
              const IconComponent = iconMap[service.icon];
              return (
                <div
                  key={service.id}
                  className={`network-card animated ${animateIn ? 'fadeIn' : ''}`}
                  style={{ transitionDelay: `${index * 100}ms` }}
                >
                  <div className="bg-[#B8FF3B] w-16 h-16 rounded-2xl flex items-center justify-center mb-4">
                    <IconComponent size={32} className="text-[#1B4332]" strokeWidth={2} />
                  </div>
                  <h3 className="network-card-title">{service.title}</h3>
                  <p className="network-card-content">{service.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-[#F8FAF9]">
        <div className="container">
          <div className="bg-white border border-gray-200 rounded-[32px] p-8 md:p-16 text-center shadow-lg">
            <div className="max-w-3xl mx-auto">
              <h2 className="heading-1 mb-6">Ready to Transform Your Business?</h2>
              <p className="body-large mb-8">
                Schedule a consultation with Oz Altun, PhD and his team and discover how technology can revolutionize your operations.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <Link to="/contact" className="btn-primary">
                  Get Started Today
                </Link>
                <div className="flex items-center gap-2 text-[#1B4332]">
                  <CheckCircle size={20} className="text-[#0EA5E9]" />
                  <span className="font-medium">Free Initial Consultation</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
